import * as API from '../_api';

import uuidv4 from 'uuid/v4';

const randomId = () => `_${Math.random().toString(36).substr(2, 9)}`;

// @ts-ignore
export const create = async ({ dispatch }, one) => {
  try {
    await API.create(one);
    dispatch('snackbar/success', 'Mitglied wurde hinzugefügt', { root: true });
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, { root: true });
    return false;
  }
  // try {
  //   if (image) {
  //     const imageName = `${randomId()}.${image.name.split('.').pop()}`;
  //     await API.uploadMemberImage(imageName, image);
  //     user.imageUrl = `https://images.einkaufskreis.at/member/${imageName}`;
  //   } else {
  //     throw new Error('Image is missing');
  //   }
  //   await API.create(user);
  //   return true;
  // } catch (ex) {
  //   dispatch('snackbar/error', ex, { root: true });
  //   return false;
  // }
};

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const update = async ({ dispatch }, one) => {
  try {
    await API.update(one);
    dispatch('snackbar/success', 'Änderungen wurden gespeichert', { root: true });
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const del = async ({ dispatch }, user) => {
  try {
    await API.del(user);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const uploadImage = async ({ dispatch }, image) => {
  try {
    const uuid = uuidv4();
    const filename = `${uuid}.png`;
    await API.uploadImage(`full/${filename}`, image);
    return filename;
  } catch (ex) {
    dispatch('snackbar/error', ex, { root: true });
    return false;
  }
};

// @ts-ignore
export const sendToAll = async ({ commit, dispatch }) => {
  try {
    await API.sendToAll();
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, { root: true });
    return false;
  }
};
